import React from 'react';
import { useProducts } from '../useProducts';
import { useSiteSettings } from '../SiteSettingsContext';
import { HOME_COPY_DEFAULTS } from '../content/pageCopyDefaults';
import ProductShelfSection from '../components/ProductShelfSection';
import ProductShelfCard from '../components/ProductShelfCard';
import { useRecentlyViewedProducts } from './useRecentlyViewedProducts';

/**
 * Horizontal shelf of recently viewed products (localStorage).
 */
export default function RecentlyViewedStrip({
  className = '',
  excludeCategorySlug = '',
  excludeProductId = '',
  limit = 8,
  title,
  subtitle,
  eyebrow,
  layout = 'auto',
}) {
  const { products, allProducts } = useProducts();
  const { settings: site } = useSiteSettings();
  const homeCopy = site.page_copy?.home || {};

  const items = useRecentlyViewedProducts(products, allProducts, {
    excludeCategorySlug,
    excludeProductId,
    limit,
  });

  if (items.length === 0) return null;

  const isHome = className.includes('home-recently-viewed');
  const shelfLayout = isHome || layout !== 'grid' ? 'scroll' : 'grid';

  const heading = title || homeCopy.recently_viewed_title || HOME_COPY_DEFAULTS.recently_viewed_title;
  const lead = subtitle || homeCopy.recently_viewed_lead || HOME_COPY_DEFAULTS.recently_viewed_lead;
  const kicker =
    eyebrow || homeCopy.recently_viewed_eyebrow || HOME_COPY_DEFAULTS.recently_viewed_eyebrow;

  const cards = items.map(({ product, categorySlug }) => (
    <div className="product-shelf__cell" key={`${categorySlug}-${product.id}`}>
      <ProductShelfCard product={product} categorySlug={categorySlug} />
    </div>
  ));

  return (
    <ProductShelfSection
      eyebrow={isHome ? kicker : ''}
      title={heading}
      lead={lead}
      layout={shelfLayout}
      tone="default"
      className={`product-shelf--recent ${className}`.trim()}
      ariaLabel="Recently viewed products"
      actionHref={isHome ? '/shop' : ''}
      actionLabel={isHome ? homeCopy.recently_viewed_action || HOME_COPY_DEFAULTS.recently_viewed_action : ''}
    >
      {cards}
    </ProductShelfSection>
  );
}
